import React from "react";
import TuleButton from "../../../../common/components/atom/TuleButton.tsx/TuleButton";
import ChipSrc from "../../../../assets/chip.png";
import useNavigationApp from "../../../../navigation/useNavigationApp";
import useQueryURL from "../../../../common/hooks/useQueryURL";
import { useAuth } from "../../../auth/hooks";
import { userRoles } from "../../../user/types/user.types";
export default function AddNewHardwareBtn({
  goToCreateNewHardwareMode,
  modalId,
}: {
  goToCreateNewHardwareMode?: boolean;
  modalId?: string;
}) {
  const { goToNewHardware } = useNavigationApp();
  const { setQueryValue } = useQueryURL();
  const { userRole } = useAuth();

  if (!userRole) {
    return <></>;
  }

  if ( userRole < userRoles.SUPER_ADMIN){
    return <></>
  }

  const modalIdFound = modalId || "addNewHardwareModal";
  const onClick = () => {
    if (goToCreateNewHardwareMode) {
      goToNewHardware();
      return;
    }

    setQueryValue({
      [modalIdFound]: "true",
    });
  };
  return (
    <TuleButton
      label="Créer un nouveau Hardware"
      onClick={onClick}
      color={{
        text: "white",
        background: "#042536",
        border: "#3684A650",
      }}
      ImageRender={() => <ChipImage />}
    />
  );
}

const ChipImage = () => {
  return (
    <img
      style={{
        width: "100%",
        height: "100%",

        marginLeft: "35%",
        scale: "1.8",
        objectFit: "contain",
      }}
      src={ChipSrc}
      alt="Chip"
    />
  );
};
